import Autosuggest from 'react-autosuggest';
import {useState} from "preact/hooks";

const classes = [
    'react-autosuggest__container',
    'react-autosuggest__input',
    'react-autosuggest__input--focused',
    'react-autosuggest__input--open',
    'react-autosuggest__suggestions-container',
    'react-autosuggest__suggestions-container--open',
    'react-autosuggest__suggestions-list',
    'react-autosuggest__suggestion',
    'react-autosuggest__suggestion--highlighted',
];

export default function SearchInput({ label, name, placeholder, getOptions, value, onChange, validationError, canModifyDetails }) {
    let lastRequestId = null;
    const [isLoading, setIsLoading] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [results, setResults] = useState({});

    const loadSuggestions = (value) => {
        // if (lastRequestId !== null) {
        //     clearTimeout(lastRequestId);
        // }
        setIsLoading(true);

        // lastRequestId = setTimeout(() => {
        getOptions(value)
            .then(res => res.json())
            .then(options => {
                setResults({[value]: options});
                setSuggestions(options)
            })
            .finally(() => setIsLoading(false));
        // }, 1000);
    }

    const onSuggestionsFetchRequested = ({ value }) => {
        if (value.length < 3) {
            return;
        }
        if (results[value]) {
            return results[value];
        }
        setIsLoading(true);
        loadSuggestions(value);
    };

    const onSuggestionsClearRequested = () => {
        setSuggestions([]);
    };

    const getSuggestionValue = (suggestion) => {
        return suggestion.label;
    }

    const renderSuggestion = (suggestion) => {
        return (
            <span>{suggestion.label}</span>
        )
    }

    return (
        <div className="esc-ii-flex esc-ii-flex-col">
            <label htmlFor={`#` + name} className="esc-ii-mb-3 esc-ii-flex esc-ii-justify-between">
                <span className="esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-[10px] lg:esc-ii-text-xs">
                    {label}
                </span>
                <svg className={`${ ! isLoading ? 'esc-ii-hidden ': ''}esc-ii-animate-spin -esc-ii-ml-1 esc-ii-mr-3 esc-ii-h-5 esc-ii-w-5 esc-ii-text-black`} xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                    <circle className="esc-ii-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path className="esc-ii-opacity-75" fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            </label>
            {canModifyDetails ? (
                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    renderInputComponent={(inputProps) => (
                        <input {...inputProps} isp_ignore  />
                    )}
                    inputProps={{
                        placeholder,
                        value,
                        onChange,
                    }} />
            ) : (
                <p className="esc-ii-font-montserrat esc-ii-text-base lg:esc-ii-text-lg">{value}</p>
            )}
            {validationError && (
                <p className="esc-ii-font-montserrat esc-ii-text-[10px] lg:esc-ii-text-xs esc-ii-text-red-600 esc-ii-mt-2">{validationError}</p>
            )}
        </div>
    );
}
